// NATIVE 
import * as React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


// CUSTOM 
import { SnackAlert } from '../../SnackAlert';
import { useDispatch, useSelector } from 'react-redux';
import { MessagesDrawerRight } from '../../MessagesDrawerRight';
import { EditCargo } from '../../cargos/editar/EditCargo';
import editCargoFormModel from '../../cargos/formModels/editar/editCargoFormModel';
import validationSchema from '../../cargos/formModels/editar/validationSchema';
import formInitialValues from '../../cargos/formModels/editar/formInitialValues';
import { storeEditCargo } from '../../../store/cargos';
import { ModalSessionExpired } from '../../generics/ModalSessionExpired';
import MultipleSnackbars from '../../MultipleSnackbars';
import { timeToClosedToast } from '../../../commons';
import { closeSessionGlobal } from '../../../commons/utils';




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));





/**
 * EditDialogCargo component renders a modal dialog for editing cargo details.
 * 
 * @param {object} props - The properties object.
 * @param {boolean} props.open - Determines if the modal is open or closed.
 * @param {function} props.handleCloseModalEditarCargo - Function to handle closing the modal.
 * @param {boolean} [props.buttons=false] - Optional prop to show or hide buttons.
 * 
 * @returns {JSX.Element} The rendered EditDialogCargo component.
 * 
 * @component
 * 
 * @example
 * // Example usage of EditDialogCargo component
 * <EditDialogCargo 
 *   open={true} 
 *   handleCloseModalEditarCargo={handleCloseFunction} 
 *   buttons={true} 
 * />
 * 
 * @remarks
 * This component uses Formik for form handling and validation, and Redux for state management.
 * It also includes various state hooks for managing UI states such as alerts and submission status.
 * 
 * @see {@link https://formik.org/docs/overview} for more information on Formik.
 * @see {@link https://react-redux.js.org/} for more information on Redux.
 */
export const EditDialogCargo = (props:any) =>  {


  //  PROPS 
  const{ open, handleCloseModalEditarCargo, buttons = false } = props;



  // USE DISPATCH 
  const dispatch = useDispatch();



  // DATA MODEL 
  const { formId, formField } = editCargoFormModel;
  const currentValidationSchema = validationSchema[0];

  


   // USE STATE 
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [percentaje_CARGO, setPercentajecARGO] = React.useState(0);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]); 
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });
  

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);
  
  const [txtBtnEditCargo, setTxtBtnEditCargo] = React.useState<string>('Editar Cargo');
   


  
  //  USE EFFECT 
  React.useEffect(() => {
      setIsSubmiting(!open);
  }, [props]);
  

  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalEditarCargo(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {



    setTxtBtnEditCargo('Un Monento...')
    actions.setSubmitting(true);
    setIsSubmiting(true);

    const response = await dispatch( storeEditCargo(values) );

   
   const result =  await validateResponse(response, ' (Editar Cargo )');


   await setTxtBtnEditCargo('Editar Cargo');


   if ( response.code == 409) {
        setIsSubmiting(false);
   }


    
    if (!result) {
       return false;
    }

    setIsSubmiting(false);

    if (response.ok) {
        
      const message:any = {
        msg: 'Cargo Editado Con Exito',
        status: 'success'
      };
    
      await setMsgSnack(message);
      await setAlertSnack(true);

      actions.resetForm();
      actions.setSubmitting(false);
      handleCloseModalEditarCargo(false);

    }
    
    
    

  }



  const validateResponse = async(response:any, textActionConcat: string) => {
      
      
          if (  response.code == 401  ) {
            await localStorage.removeItem('lastSelectedQypht');
            await closeSessionGlobal();
            await handleCloseModalEditarCargo(false);
            setModalSessionExpired(true);
            return false;
          }
  
        
          // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
  
          if (!response.ok && response.code == 403 ) { 

            const errors:any = {
                msg: response.errors[0]+' '+textActionConcat,
                status: 'error'
            };
            
            await setMsgSnack(errors);
            await setAlertSnack(true);
  
            return false;
          }
          



          // 403 EL DATO YA SE ENCUENTRA REGISTRADO
        if (!response.ok && response.code == 409 ) { 
    
          const errors:any = {
              msg: response.errors[0]+' '+textActionConcat,
              status: 'error'
          };
          
          await setMsgSnack(errors);
          await setAlertSnack(true);

          return false;
        }
  
          
          // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
          if (!response.ok && response.code == 400 ) { 
  
            const errors:any = [];
  
            response.errors.forEach( (element:any) => {
                
                errors.push({
                  type: 'error',
                  text: element
                })
            });
  
              
            setMessagesAlerts(errors);
            return false;
  
          }
  
          return true;
        
  }
  
  

  return (
    <React.Fragment>

      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />

      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Editar Cargo
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
        <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
              <Form id={formId}>
                <EditCargo formField={formField}/>

                <Button
                    disabled={isSubmiting}
                    style={{margin:5, float: 'right'}}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    {
                      txtBtnEditCargo
                    }
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}




